import { Link } from '@tanstack/react-router';

import { PageHeader } from '../components/PageHeader';
import { NavLabel } from '../components/shell/NavLabel';
import { useNavModel } from '../components/shell/useNavModel';

/** What each settings page holds, in one line, so the index reads like the Helios CRM's. */
const SETTING_HINT: Readonly<Record<string, string>> = {
  '/primer-dia': 'Lo que falta para abrir tu negocio en Dale.',
  '/mesas': 'El plano de tu local: cada reserva cae en su lugar.',
  '/planes': 'Lo que tus clientes pagan por adelantado, con su saldo.',
  '/servicios': 'Lo que ofreces, con precio y duración.',
  '/agenda': 'Tu horario de atención.',
  '/equipo': 'Tu gente, sus horarios y qué ve cada perfil.',
  '/ofertas': 'Descuentos para las horas flojas.',
  '/negocio': 'Nombre, fotos, dirección y cómo te encuentran.',
  '/herramientas': 'Calendario, paquetes, espacios y clases: lo que usas de Dale.',
  '/configuracion': 'El estilo del panel en este dispositivo.',
};

export function AjustesPage() {
  const { settings } = useNavModel();
  const links = [...settings, { to: '/configuracion', label: 'Apariencia' }];
  return (
    <div className="page">
      <PageHeader title="Ajustes" description="Cómo funciona tu negocio en Dale." />
      <div className="hs-settings-cards">
        {links.map((link) => (
          <Link key={link.to} to={link.to} className="hs-settings-card">
            <strong>
              <NavLabel label={link.label} lock={'lock' in link ? link.lock : undefined} />
            </strong>
            <span>{SETTING_HINT[link.to] ?? ''}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
